module.exports = __webpack_public_path__ + "static/media/search.d11eb953.png";